import React from 'react';

export const DataContext = React.createContext();
export const LocaleContext =  React.createContext();
export const LoadingContext = React.createContext();
export const ScrollsContext = React.createContext();
export const FeedbackContext = React.createContext();
